<template>
  <div class="grid-job-widget">
    <span class="job-type full-type" style="color:gray"><i class="ti-location-pin"></i> {{ $i18n.locale === 'zh' ? job.data.work_location.c_fullname : job.data.work_location.e_fullname }}</span>
    <div class="job-like" v-if="featured">
      <span class="skill-tag" style="float:right">{{ $t('jobs.featured') }}</span>
    </div>
    <div :class="{'job-intern': isIntern, 'job-magex': isMagex}" :style="jobBoxStyle"></div>
    <div class="u-content">
      <div class="avatar box-80">
        <router-link :to="'jobs/' + this.job.data.id">
          <img class="img-responsive" :src="img" alt="">
        </router-link>
      </div>
      <h5><router-link :to="'/jobs/' + this.job.data.id">{{ job.data.title.name }}</router-link></h5>
      <p class="text-muted">{{ job.data.company_desc || job.data.recruiting_company.name.name }}</p>
      <span class="theme-cl">{{ salary }}</span>
    </div>
    <div class="job-type-grid">
      <router-link :to="'/jobs/' + this.job.data.id" class="btn theme-btn-outlined mrg-5">{{ $t('hot-jobs.apply') }}</router-link>
    </div>
  </div>
</template>
<style>
@media only screen and (max-width:480px) {
  .grid-job-widget {
    height: 320px;
  }
  span.skill-tag {
    position: absolute;
  }
  .skill-tag:before {
    border-top: 0px solid transparent;
    border-left: 0px solid #d81c00;
    border-bottom: 0px solid transparent;
    content: "";
    height: 0;
    position: absolute;
    top: 0;
    right: -8px;
    width: 0;
  }
}
</style>
<script>
import jobStyle from '@/utils/job-style'

export default {
  name: 'JobBox',
  props: ['job', 'config'],
  computed: {
    salary: function() {
      return this.salaryLabel(this.job.data.salary_from, this.job.data.salary_to, this.job.data.salary_negotiable)
    },
    img: function() {
      let img = '/img/no-logo.heic',
          photo = null
      if (this.job.data.recruiting_company)
          photo = this.job.data.recruiting_company.photo
      if(photo) {
        let ext = photo.filename.substr(photo.filename.lastIndexOf('.') + 1)
        img = this.IMG_PREFIX + photo.path + '/' + photo.id + '_company_photo_m.' + ext + '?r=' + Math.random()
      }
      return img
    },
    featured: function() {
      if (this.job.data.genes != null) {
        if (this.job.data.genes.client_company != null && this.job.data.genes.client_company.includes('Rz'))
          return true
      }
      return false
    },
    isIntern: function() {
      if (this.job.data.genes != null) {
        if (this.job.data.genes.hirer != null && this.job.data.genes.hirer.includes('Qk'))
          return true
      }
      return false
    },
    isMagex: function() {
      if (this.job.data.genes != null) {
        if (this.job.data.genes.hirer != null && this.job.data.genes.hirer.includes('qN'))
          return true
      }
      return false
    },
    jobBoxStyle: vm => jobStyle.jobBoxStyle(vm.job.data, vm.config)
  }
}
</script>